import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@shared/services/userpermissions.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
	const permission = route.data['permission'] as string | string[] | undefined;
	const permissions = (Array.isArray(permission) ? permission : permission ? [permission] : []).filter((p) => p !== '');
	if (permissions.length === 0) return true;

	const userPermissions = inject(UserPermissionsService);
	const router = inject(Router);

	if (userPermissions.hasPermissions(permissions)) return true;

	sessionStorage.setItem('Link.Illegal', 'x');
	return router.parseUrl('/core');
};
